import {
  Button,
  DatePicker,
  Divider,
  Drawer,
  Form,
  Input,
  Segmented,
} from "antd";
import { ClearOutlined } from "@ant-design/icons";
import React, { useState } from "react";
import { colors } from "../../../../../../Utils/temas";
import moment from "moment";

const PERIODOS = {
  NENHUM: "Nenhum",
  HOJE: "Hoje",
  ONTEM: "Ontem",
  ULTIMOS_7_DIAS: "Últimos 7 dias",
  MES_ATUAL: "Mês atual",
};

export const FiltrosEstacao = ({ visible, onClose, onFinish, onClear }) => {
  const [periodoSelecionado, setPeriodoSelecionado] = useState(PERIODOS.NENHUM);

  const [form] = Form.useForm();

  const options = Object.values(PERIODOS);

  const handleClear = () => {
    form.resetFields();
    onClear();
    setPeriodoSelecionado(PERIODOS.NENHUM);
  };

  const handlePeriodoChange = (periodo) => {
    const hoje = moment();

    setPeriodoSelecionado(periodo);

    switch (periodo) {
      case PERIODOS.HOJE:
        form.setFieldsValue({
          data_acesso_inicial: hoje.clone().startOf("day"),
          data_acesso_final: hoje.clone().endOf("day"),
        });
        break;

      case PERIODOS.ONTEM: {
        const ontem = hoje.clone().subtract(1, "day");

        form.setFieldsValue({
          data_acesso_inicial: ontem.clone().startOf("day"),
          data_acesso_final: ontem.clone().endOf("day"),
        });
        break;
      }

      case PERIODOS.ULTIMOS_7_DIAS:
        form.setFieldsValue({
          data_acesso_inicial: hoje.clone().subtract(7, "day").startOf("day"),
          data_acesso_final: hoje.clone().endOf("day"),
        });
        break;

      case PERIODOS.MES_ATUAL:
        form.setFieldsValue({
          data_acesso_inicial: hoje.clone().startOf("month"),
          data_acesso_final: hoje.clone().endOf("month"),
        });
        break;

      case PERIODOS.NENHUM:
        form.setFieldsValue({
          data_acesso_inicial: null,
          data_acesso_final: null,
        });
        break;

      default:
        break;
    }
  };

  const handleDateChange = () => {
    setPeriodoSelecionado(PERIODOS.NENHUM);
  };

  return (
    <Drawer visible={visible} onClose={onClose} width="22.5%">
      <Form
        form={form}
        onFinish={onFinish}
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div>
          <div>
            <label style={{ fontWeight: "500" }}>Nome da Estação:</label>
            <Form.Item name="nome_estacao">
              <Input />
            </Form.Item>
          </div>

          <div style={{ display: "flex", gap: 8 }}>
            <div style={{ width: "100%" }}>
              <label style={{ fontWeight: "500" }}>Data Acesso Inicial:</label>
              <Form.Item name="data_acesso_inicial">
                <DatePicker
                  format="DD/MM/YYYY"
                  style={{ width: "100%" }}
                  onChange={handleDateChange}
                />
              </Form.Item>
            </div>

            <div style={{ width: "100%" }}>
              <label style={{ fontWeight: "500" }}>Data Acesso Final:</label>
              <Form.Item name="data_acesso_final">
                <DatePicker
                  format="DD/MM/YYYY"
                  style={{ width: "100%" }}
                  onChange={handleDateChange}
                />
              </Form.Item>
            </div>
          </div>

          <Segmented
            options={options}
            value={periodoSelecionado}
            onChange={handlePeriodoChange}
          />
        </div>

        <div>
          <Divider />

          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              style={{
                background: colors.secondary,
                color: "white",
                fontWeight: "500",
              }}
              htmlType="submit"
            >
              Filtrar
            </Button>

            <Button onClick={handleClear} icon={<ClearOutlined />}>
              Limpar
            </Button>
          </div>
        </div>
      </Form>
    </Drawer>
  );
};
